export default __webpack_public_path__ + "static/calipersrectangle-ac7dc4a931f3b69ba3cc24511d2f8e98.png";